module.exports = __webpack_public_path__ + "static/media/black.3ae124af.png";